import { createModel } from '@rematch/core';
import dayjs from 'dayjs';
import { initReduxFn, setStateReducer } from '@/std/redux';
import type { RootModel } from '..';
import type { NotaFiscalState } from './types';
import { effects } from './effects';

const initialState: NotaFiscalState = {
    calcularImpostos: initReduxFn,
    cancelarNotaFiscal: initReduxFn,
    compartilharSend: initReduxFn,

    // VALORES PARA DRAWERS
    enviarExpedicao: initReduxFn,
    estornarEstoque: initReduxFn,
    estornarFinanceiro: initReduxFn,

    // FORM
    formAction: undefined,
    formError: undefined,
    gerarRelatorio: initReduxFn,
    gerarRelatorioMultiple: initReduxFn,

    // EFFECTS
    get: initReduxFn,
    getOne: initReduxFn,
    getReceitaFiscal: initReduxFn,

    // TABELAS
    getTable: {
        // FILTROS
        filterDateRange: {
            end: dayjs().add(1, 'week'),
            start: dayjs().subtract(1, 'week'),
        },

        // LOADING NA TABELA PARA MOSTRAR ALGUMA AÇÃO EXECUTANDO
        loadingTable: false,

        // PAGINAÇÃO
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: false,
            showTotal: () => '',
            total: 10,
        },
        qtdRegistros: 10,
        registroInitial: 0,

        // ORDENAÇÃO
        sortParams: {
            fieldName: '',
            orderDirection: 'asc',
            shouldSort: false,
        },

        // TOTAIS REGISTROS (PARA PAGINAÇÃO)
        totalRegistrosTable: 0,

        // UPDATE TABLE ON CHANGES
        updateTable: false,
    },
    lancarEstoque: initReduxFn,
    lancarFinanceiro: initReduxFn,
    post: initReduxFn,
    preVisualizarDanfe: initReduxFn,
    put: initReduxFn,
    remove: initReduxFn,
    showDrawerCancelarNf: false,

    totalizador: initReduxFn,
    verifyAndGerarRelatorioPdf: initReduxFn,
};

export const NotaFiscalModel = createModel<RootModel>()({
    effects,
    reducers: setStateReducer<NotaFiscalState>(),
    state: initialState,
});
